<template>
  <AuthLayout
    :sidebar-title="isAdmin ? 'Admin portal' : 'Welcome back to your care portal'"
    :sidebar-text="isAdmin ? 'Your patient panel, their progress — one view, full picture.' : 'Your eye health, all in one place — test, ask, connect.'"
    :support-phone="supportPhone"
    :is-admin="isAdmin"
    :title="isAdmin ? 'Sign in to Admin' : 'Sign in'"
    :subtitle="isAdmin ? 'Enter your email or phone number to get started' : 'Enter your phone number or email address to get started'"
  >
    <form
      action="javascript:void(0)"
      :autocomplete="clearOnReload ? 'off' : 'on'"
      @submit.prevent="handleSubmit"
    >
      <AuthField
        id="identifier-input"
        ref="identifierField"
        v-model="identifier"
        name="username"
        label="Phone number or email address"
        placeholder="e.g. example@gmail.com or 602-555-0123"
        :autocomplete="clearOnReload ? 'off' : 'username'"
        input-mask="phone-or-email"
        :error="displayError"
        required
      />

      <div class="auth-login__actions">
        <AuthButton type="submit" :loading="loading" :disabled="!identifier" trailing-icon="arrow-right">
          Continue
        </AuthButton>
      </div>

      <div v-if="!isAdmin && registerUrl" class="auth-login__signup-hint">
        <span class="auth-login__signup-text">
          You don't have an account?
          <a :href="registerUrl" class="auth-login__link auth-login__link--plain">Sign up</a>
        </span>
      </div>
    </form>

<!--    <template #footer>-->
<!--      <button v-if="!isAdmin" type="button" class="auth-login__help-link" @click="openHelp">-->
<!--        <AuthIcon name="info" />-->
<!--        I need help signing in-->
<!--      </button>-->
<!--    </template>-->
  </AuthLayout>
</template>

<script setup>
import { computed, nextTick, onMounted, ref, toRef, watch } from 'vue'
import AuthLayout from '../../shared/components/AuthLayout.vue'
import AuthField from '../../shared/components/AuthField.vue'
import AuthButton from '../../shared/components/AuthButton.vue'
import AuthIcon from '../../shared/components/AuthIcon.vue'
import { useAuthHelp } from '../../shared/composables/useAuthHelp.js'

const props = defineProps({
  loading:      { type: Boolean, default: false },
  error:        { type: String,  default: '' },
  supportPhone: { type: String,  default: '815-908-2020' },
  registerUrl:  { type: String,  default: '' },
  isAdmin:      { type: Boolean, default: false },
  clearOnReload: { type: Boolean, default: false },
})

const emit = defineEmits(['submit'])

const IDENTIFIER_MAX_LENGTH = 255
const identifier = ref('')
const identifierField = ref(null)
const clientError = ref('')
const displayError = computed(() => clientError.value || props.error)
const { openHelp } = useAuthHelp(toRef(props, 'supportPhone'))

watch(identifier, () => {
  clientError.value = ''
})

onMounted(() => {
  if (!props.clearOnReload) return

  nextTick(() => {
    identifier.value = ''

    const input = identifierField.value?.getInputElement?.()
    if (input) input.value = ''
  })
})

const handleSubmit = () => {
  const inputValue = identifierField.value?.getInputElement?.()?.value ?? ''
  const resolvedIdentifier = (identifier.value || inputValue).trim()

  if (!resolvedIdentifier) return

  if (resolvedIdentifier.length > IDENTIFIER_MAX_LENGTH) {
    clientError.value = 'The identifier is too long.'
    identifierField.value?.getInputElement?.()?.focus()
    return
  }

  identifier.value = resolvedIdentifier
  emit('submit', resolvedIdentifier)
}
</script>
